import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class AccountService {
	constructor(private http: HttpClient) {}

	getSignature() {
		return this.http
			.get<any>('accounts/signature')
			.toPromise()
			.catch(() => undefined);
	}
}
